<!-- Header section -->
<login-header></login-header>
<!-- choose a plan info section -->
<div class="choose_a_plan gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
    <div class="plan_section px-90 m-auto">
        <div class="plan_head py-3">
            <h3 class="h3 my-3 text-center">Choose A Plan</h3>
        </div>

        <div class="choose_plan_content pb-5">
            <!-- loop plan details -->
            <div class="choose_plan no_free_pack mb-4">
                <div class="plan_ltd_oofer"><p class="mb-0">Limited time offer!</p></div>
                <div class="plan_details">
                    <h4 class="fc_plan_head mb-1 text-center">14-Day Free Trial</h4>
                    <p class="fc_amount mb-1 text-center">Try Family Central for free</p>
                    <div class="fc_sign_up" style="margin-top: 17px;">
                        <p class="fc_card_required mb-1 text-center">No credit card required</p>
                        <button type="button" class="border_btn black_border" routerLink="/questionnaires">Sign up</button>
                    </div>
                    <p class="fc_sub_period">14 days - Free subscription</p>
                    <ul class="plan_summery pb-4">
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            8 total members
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            250 GB storage
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            Video concierge support (8am-5pm)
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            Chat/email & phone support
                        </li>
                    </ul>
                </div>
            </div>
            <div class="choose_plan no_free_pack mb-4">
                <div class="plan_details">
                    <h4 class="fc_plan_head mb-1 text-center">$199</h4>
                    <p class="fc_amount mb-1 text-center">One-year subscription <br> <span class="bold-text">$16.60</span>/month</p>
                    <div class="fc_sign_up">
                        <button type="button" class="primary_btn" routerLink="/questionnaires">Select plan</button>
                    </div>
                    <ul class="plan_summery pb-4">
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            8 total members
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            250 GB storage
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            Video concierge support (8am-5pm)
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            Chat/email & phone support
                        </li>
                    </ul>
                    <!-- Addon's price details -->
                    <div class="fam_expan_addon mt-4">
                        <h5>Family Expansion Add-ons</h5>
                        <ul class="plan_summery_detail pb-4">
                            <li>
                                $99 for additional 8 members
                            </li>
                            <li>
                                $99 for additional 250 GB storage
                            </li>
                        </ul>
                    </div>

                    <!-- Addon's garentree details -->
                    <div class="Addon_garentree mt-4">
                        <h5>30-day satisfaction guarantee</h5>
                        <p>If for any reason within 30 days, you do not want to continue Family Central, we will refund your purchase to the original form of payment used.</p>
                    </div>
                </div>
            </div>
            <div class="choose_plan no_free_pack mb-4">
                <div class="plan_details">
                    <h4 class="fc_plan_head mb-1 text-center">$299</h4>
                    <p class="fc_amount mb-1 text-center"> Three-year subscription ($298 savings) <span class="bold-text">$8.30</span>/month </p>
                    <div class="fc_sign_up">
                        <button type="button" class="primary_btn" routerLink="/questionnaires">Select plan</button>
                    </div>
                    <ul class="plan_summery pb-4">
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            8 total members
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            250 GB storage
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            Video concierge support (8am-5pm)
                        </li>
                        <li>
                            <img width="13" height="12" src="/assets/images/Ellipse_tick_mark.svg" alt=""/>
                            Chat/email & phone support
                        </li>
                    </ul>
                    <!-- Addon's price details -->
                    <div class="fam_expan_addon mt-4">
                        <h5>Family Expansion Add-ons</h5>
                        <ul class="plan_summery_detail pb-4">
                            <li>
                                $150 for additional 8 members
                            </li>
                            <li>
                                $150 for additional 250 GB storage
                            </li>
                        </ul>
                    </div>

                    <!-- Addon's garentree details -->
                    <div class="Addon_garentree mt-4">
                        <h5>30-day satisfaction guarantee</h5>
                        <p>If for any reason within 30 days, you do not want to continue Family Central, we will refund your purchase to the original form of payment used.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Have any questions section -->
<div class="have_questions">
    <div class="have_questions_section px-90 m-auto">
        <div class="have_question_faq py-5">
            <div class="questions_tail">
                <h6>Have Questions?</h6>
                <p>We have 24/7 <br>Support Available</p>
                <a class="border_btn red_border" style="text-align: center;" routerLink="/contactus">Contact us</a>
            </div>
            <div class="questions_faq">
                <div class="questions_accordions">
                        <!-- questions of FAQ's -->
                        
                                <div class="faq-accordion" id="accountAccordion">
                                    <!-- loop of questions  -->
                                    <div class="card">
                                        <div class="card-header">
                                            <a class="collapsed btn" data-bs-toggle="collapse" href="#accountQues2">
                                                Can I cancel anytime?
                                            </a>
                                        </div>
                                        <div id="accountQues2"  data-bs-parent="#accountAccordion" class="collapse">
                                            <div class="card-body lp_p">
                                                If a client chooses to cancel their subscription, they will be given 30 days to move the data to an alternate storage location.  After 30 days, we will delete all data from our records.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header">
                                            <a class="collapsed btn" data-bs-toggle="collapse" href="#accountQues3">
                                                Is my information secure?
                                            </a>
                                        </div>
                                        <div id="accountQues3"  data-bs-parent="#accountAccordion" class="collapse">
                                            <div class="card-body lp_p">
                                                At the core of Family Central’s functionality is its security. Our commitment to each and every family member is to keep their personal information safe and secure.  Family Central uses bank-level encryption technology, is SOC 2 compliant, HIPAA compliant, 
GDPR ready, CCPA ready, and registered with Dun & Bradstreet. Microsoft Azure.com provides our data protection through AES-256 encryption on our applications and services at their global data centers, and Artic Wolf provides 24/7 monitoring detection, 
risk management, and proactive security posture for Family Central, as well as global Fortune 100 companies. 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header">
                                            <a class="collapsed btn" data-bs-toggle="collapse" href="#accountQues6">
                                                Is the app available on Android devices?
                                            </a>
                                        </div>
                                        <div id="accountQues6" data-bs-parent="#accountAccordion" class="collapse">
                                            <div class="card-body lp_p">
                                                Yes!  You can download the Family Central app to your phone.  We recommend iOS 13 or newer or Android 9 or newer operating systems to best support the Family Central app.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            
                    
                </div>
            </div>
        </div>
    </div>
    
</div>

<!-- Choose Right plan section -->
<div class="get_started_section">
    <div class="get_started_content d-grid align-items-center">
        <div class="get_started_image">
            <img class="w-100" src="/assets/images/pricing_family_pic.webp" alt="" loading="lazy">
        </div>
        <div class="get_started_box">
            <h2 class="h2 mb-4 text-capitalize">Choose The Right Plan For You And Join The Family Central Family. </h2>
            <form [formGroup]="emailForm">
                <div class="form-group get_started_field">
                    <input type="email" name="email" id="email" class="form-control" placeholder="Enter your email address" formControlName="email">
                    <button type="submit" class="primary_btn" (click)="goToOnboard()">Sign up</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>